import { GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
import { FC } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import styled from "styled-components";
import "./dashboard.scss";
//import { useDashboardData } from "../../../Hooks/useDashboard";
//import LoadingIndicator from "../../LoadingIndicator/index";
import { StuntTypeProp } from "../../../CustomTypes/Filters";
import { useHookForApi } from "../../../Hooks/useHookForApi";
import { errorToast } from "../../../Utils/toastMessage";
import CustomToast from "../../CustomToast/CustomToast";

const ChartWarapper = styled.div`
  max-width: auto;
  margin: 0 auto;
`;
const PalletDetail: FC<StuntTypeProp> = (stuntType) => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const onSuccess = (data: any) => {
    if (data.isAxiosError && data.name === 'Error' && data.message === "Network Error") {
      errorToast(JSON.stringify(`Unable to connect with Journey service and possible reason is: (${data})`));
    }
  };
  const onError = (error: any) => {
    //console.clear()
  };

  //purchaseorders/dashboard
  const {
    //isLoading: isDataLoading,
    data:response,
    //isFetching,
  //} = useDashboardData(onSuccess, onError, `masterplan/dashboard${stuntType.stuntType}`);
  } = useHookForApi(onSuccess, onError,0,0, `masterplan/dashboard${stuntType.stuntType}`);

  const labels = [
    "Picked",
    "Shipped",
    "Hold",
    "Ship Tomorrow",
    "Not on Journey",
  ];
  const dashboardData = {
    labels,
    datasets: [
      {
        //axis: 'x',
        label: `Number of Pallets ${response?.data?.totalCount}`,
        data: [
          response?.data?.picked,
          response?.data?.shipped,
          response?.data?.hold,
          response?.data?.shippedTomorrow,
          response?.data?.notOnJourney,
        ],
        //fill: false,
        backgroundColor: [
          "rgba(25, 118, 210, 1)",
          "rgba(39, 69, 104, 1)",
          "rgba(248, 181, 21, 1)",
          "rgba(241, 78, 99, 1)",
          "rgba(48, 192, 205, 1)",
        ],
        borderColor: [
          "rgba(25, 118, 210, 1)",
          "rgba(39, 69, 104, 1)",
          "rgba(248, 181, 21, 1)",
          "rgba(241, 78, 99, 1)",
          "rgba(48, 192, 205, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    indexAxis: "y" as const,
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: true,
        color: "black",
        formatter: (value: any, ctx: any) => {
          let sum = 0;
          const dataArr = ctx.chart.data.datasets[0].data;
          sum = dataArr.reduce((prev: any, cur: any) => prev + cur);
          const percentage = ((value * 100) / sum).toFixed(2) + "%";
          if (percentage === "NaN%" || percentage === "0.00%") {
            return "";
          }
          return percentage;
        },
      },
    },
  };

  return (
    <>
      <div className="ln-u-soft colour">
      <GridWrapper equalHeight>
          <GridItem size="1/2">
            <div className="property">Number of Pallet 
              <h2 className="shippedTomorrowValue">{response?.data?.totalCount}</h2></div>
          </GridItem>
        </GridWrapper>

        <GridWrapper equalHeight>
          <GridItem size="1/1">
            <ChartWarapper>
              <Bar data={dashboardData} options={options} />
            </ChartWarapper>
          </GridItem>
        </GridWrapper>
      </div>
      <CustomToast />
    </>
  );
};

export default PalletDetail;
